
/**
 * 针对给出的请求实例进行本地化配置
 */
import axios from 'axios'
import * as store from "@/store"
import qs from 'qs'
import md5 from 'js-md5'
import { Modal } from 'ant-design-vue';
import storage from 'store'
const env = require("../env");
import cookie from './cookie'
// console.log(process.env);
// 创建 axios 实例
const request = axios.create({
    // API 请求的默认前缀
    baseURL: env[process.env.NODE_ENV].base_url,  //process.env 获取的是package里面的MODE值, // api的base_url
    timeout: 20000 // 请求超时时间
})
// 异常拦截处理器
const errorHandler = (error) => {
    let { message } = error
    if (message === 'Network Error') {
        message = '后端接口连接异常'
    } else if (message.includes('timeout')) {
        message = '系统接口请求超时'
    } else if (message.includes('Request failed with status code')) {
        message = '系统接口' + message.substr(message.length - 3) + '异常'
    }

    return Promise.reject(error) //注释该行，否则接口请求失败会一直请求刷新错误数据，这里保证请求一次
}
function createSign(params, signKey, timestamp, debug = false) {
    const keyArr = Object.keys(params);
    keyArr.sort();
    let str = "";
    for (let i = 0; i < keyArr.length; i += 1) {
        if (typeof (params[keyArr[i]]) == 'object') {
            params[keyArr[i]] = JSON.stringify(params[keyArr[i]]);
        }
        str = `${str}&${keyArr[i]}=${params[keyArr[i]]}`;
    }
    signKey = md5(`${signKey}${timestamp}`);
    if (debug) {
        console.log(`${str.substr(1)}&${signKey}`);
    }
    return md5(`${str.substr(1)}&${signKey}`);
}

// request interceptor
request.interceptors.request.use(config => {
    if (!cookie.get('ACCESS_TOKEN') && storage.get('ACCESS_TOKEN')) {
        window.$nuxt.$store.dispatch('Logout')
        return
    }
    const token = storage.get('ACCESS_TOKEN') || cookie.get('ACCESS_TOKEN')
    // 如果 token 存在
    // 让每个请求携带自定义 token 请根据实际情况自行修改
    if (token) {
        config.headers['User-Token'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
    }

    if (config.method === 'post') {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        config.headers['Accept'] = 'application/x-www-form-urlencoded'
        config.data = config.headers['Content-Type'] == 'application/x-www-form-urlencoded' ? qs.stringify(config.data) : config.data
    }
    // config.params = { ...config.params, 'debug': 1 } //跳出前面
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?'
        for (const propName of Object.keys(config.params)) {
            const value = config.params[propName]
            var part = encodeURIComponent(propName) + '='
            // 修改漏洞
            if (value != null && typeof (value) !== 'undefined') {
                if (typeof value === 'object') {
                    for (const key of Object.keys(value)) {
                        const params = propName + '[' + key + ']'
                        var subPart = encodeURIComponent(params) + '='
                        url += subPart + encodeURIComponent(value[key]) + '&'
                    }
                } else {
                    url += part + encodeURIComponent(value) + '&'
                }
            }
        }

        url = url.slice(0, -1)
        // 添加签名
        if (url.indexOf("?") != -1) {
            let index = url.indexOf("?");
            let result = url.substr(index + 1, url.length);   //04
            config.data = result
        }
        config.params = {}
        config.url = url
    }

    let timestamp = parseInt(new Date().getTime() / 1000);
    let params = config.data ? qs.parse(config.data) : {}
    // 应用参数
    let appConfig = { cchid: 167, appid: 10112, mdid: params.mdid ?? 100000 }
    // 请求头参数
    let signKey = `q29xwjEuGlnyPmQzh5p3SJBtbMVcTK0d${appConfig.cchid}${appConfig.appid}${appConfig.mdid}`;
    config.headers['Cchid'] = appConfig.cchid;
    config.headers['Appid'] = appConfig.appid;
    config.headers['Mdid'] = appConfig.mdid;
    config.headers['Timestamp'] = timestamp;
    config.headers['Signature'] = createSign(params, signKey, timestamp);
    return config

}, errorHandler)

// response interceptor
request.interceptors.response.use((res) => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    const errorCode = {
        '401': '认证失败，无法访问系统资源',
        '403': '当前操作没有权限',
        '404': '访问资源不存在',
        '501': '非法的token令牌',
        '502': '非法的token令牌',
        'default': '系统未知错误，请反馈给管理员'
    }
    // // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    if (code === 501 || code == 502) {
        Modal.confirm({
            title: '系统提示',
            content: '登录状态已过期，请重新登录',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            centered: true,
            onOk() {
                window.$nuxt.$store.dispatch('Logout').then(() => {
                    location.href = '/login'
                })
            },
            onCancel() {
                console.log('Cancel');
            },
        });
        return
    } else if (code === 404) {
        location.href = '/404'
        return
    }
    return res.data ? res.data : Promise.reject(msg)
}, errorHandler)

const installer = {
    vm: {},
    install(Vue) {
        Vue.use(VueAxios, request)
    }
}

export default request

export {
    installer as VueAxios,
    request as axios
}